import { useEffect } from 'react';

const useLeaveSiteAlert = (shouldWarn: boolean) => {
  useEffect(() => {
    if (!shouldWarn) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Required to trigger the dialog (modern browsers show a generic message)
      event.preventDefault();
      // Chrome requires returnValue to be set
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldWarn]); // Re-run effect when shouldWarn changes
};

export default useLeaveSiteAlert;
